import {
  Container,
  ContainerGutter,
  ContainerPadding,
  styled,
} from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { CarlineWithOffers } from 'src/types';
import { CarlineColorCard, OfferCarlineCardInfo, ShowOffersCTA, VerticalLine } from '.';

interface OfferCarlineCardWrapperProps {
  isSelected: boolean;
}

const OfferCarlineCardWrapper = styled.div<OfferCarlineCardWrapperProps>`
  width: 100%;
  display: block;
  flex-wrap: wrap;
  text-align: center;
  border: ${(props) => (props.isSelected ? '2px solid #001E50' : 'none')};
  padding: ${(props) => (props.isSelected ? '11px' : '0px')};
  padding-bottom: ${(props) => (props.isSelected ? '65px' : '0px')};
  @media all and (min-width: 560px) {
    width: 38vw;
  }
  @media all and (min-width: 960px) {
    width: 25vw;
  }
  @media all and (min-width: 1600px) {
    width: 19vw;
  }
  @media all and (min-width: 1920px) {
    width: 347.13px;
  }
`;

export interface OfferCarlineCardProps {
  carline?: CarlineWithOffers;
  selectedCarlineId?: number;
  offerPackageArray?: any;
}

export const OfferCarlineCard = (props: OfferCarlineCardProps) => {
  const { carline, selectedCarlineId, offerPackageArray } = props;
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    selectedCarlineId === carline.code ? setIsSelected(true) : setIsSelected(false);
  }, [selectedCarlineId]);

  useEffect(() => {
    selectedCarlineId === carline.code ? setIsSelected(true) : setIsSelected(false);
  }, [offerPackageArray]);

  useEffect(() => {
    const formatPrice = (price: string | number) => {
      return new Intl.NumberFormat().format(price);
    };
    const lastOffer = carline.ofertas[carline.ofertas.length - 1];
    if (props.carline.activoOcasion === 1 && !lastOffer.ocasion) {
      carline.ofertas.push({ ...carline.ofertas[0] });
      const newOcasion = carline.ofertas[carline.ofertas.length - 1];
      newOcasion.anchor = 'OCASIÓN';
      newOcasion.motorizacion = null;
      newOcasion.myRenting = 0;
      newOcasion.ivaIncluido = 0;
      newOcasion.equipamientos = null;
      newOcasion.financiacionText = 'Ocasión';
      newOcasion.plazos = null;
      newOcasion.cuotaFinal = null;
      newOcasion.cuotaTipo = null;
      newOcasion.cuota = formatPrice(props.carline.ocasion.precio);
      newOcasion.mediaAssets = { ...carline.mediaAssets };
      newOcasion.ocasion = { ...carline.ocasion };
    }
  }, []);

  return (
    <div>
      <OfferCarlineCardWrapper isSelected={isSelected}>
        <CarlineColorCard
          carlineName={carline.title}
          carlineImage={carline.mediaAssets ? (carline.mediaAssets.D6MOFASideview ? carline.mediaAssets.D6MOFASideview : carline.mediaAssets.FallbackSideview) : null} // Temporal
          carlineColors={carline.colores.exterior}
          isNew={carline.nuevo}
          isSelected={isSelected}
        />

        {isSelected ? null : (
          <Container
            padding={{ top: ContainerPadding.static300 }}
            horizontalAlign={"center"}
            gutter={ContainerGutter.static400}
            wrap={"always"}
          >
            <OfferCarlineCardInfo carline={carline} selectedCarlineId={selectedCarlineId} offerPackageArray={offerPackageArray}/>
            <ShowOffersCTA carline={carline}/>
          </Container>
        )}
      </OfferCarlineCardWrapper>
      {isSelected && <VerticalLine/>}
    </div>
  );
};
